import {
  CLIENT_LOGIN_V2,
  CLIENT_LOGIN_V2_SUCCESS,
  CLIENT_LOGIN_V2_ERROR,
  CLIENT_LOGIN_V2_EMPTY,
  CLIENT_VALIDATE_OTP_V2,
  CLIENT_VALIDATE_OTP_V2_SUCCESS,
  CLIENT_VALIDATE_OTP_V2_ERROR,
  CLIENT_VALIDATE_OTP_V2_EMPTY,
  CLIENT_RESEND_OTP_V2,
  CLIENT_RESEND_OTP_V2_SUCCESS,
  CLIENT_RESEND_OTP_V2_ERROR,
  CLIENT_RESEND_OTP_V2_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  validateOtpData: null,
  resendOtpData: null,
  message: null,
  loading: false,
  validateOtpLoading: false,
  resendOtpLoading: false,
  success: false,
  error: false,
};

const ClientLoginV2 = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_LOGIN_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_LOGIN_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_LOGIN_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_LOGIN_V2_EMPTY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        message: null,
      };
      break;

    case CLIENT_VALIDATE_OTP_V2:
      state = {
        ...state,
        validateOtpData: null,
        validateOtpLoading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_VALIDATE_OTP_V2_SUCCESS:
      state = {
        ...state,
        validateOtpData: action.payload,
        validateOtpLoading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_VALIDATE_OTP_V2_ERROR:
      state = {
        ...state,
        validateOtpData: null,
        validateOtpLoading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_VALIDATE_OTP_V2_EMPTY:
      state = {
        ...state,
        validateOtpData: null,
        validateOtpLoading: false,
        success: false,
        message: null,
      };
      break;

    case CLIENT_RESEND_OTP_V2:
      state = {
        ...state,
        resendOtpData: null,
        resendOtpLoading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_RESEND_OTP_V2_SUCCESS:
      state = {
        ...state,
        resendOtpData: action.payload,
        resendOtpLoading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_RESEND_OTP_V2_ERROR:
      state = {
        ...state,
        resendOtpData: null,
        resendOtpLoading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_RESEND_OTP_V2_EMPTY:
      state = {
        ...state,
        resendOtpData: null,
        resendOtpLoading: false,
        success: false,
        message: null,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientLoginV2;
